module.exports = __webpack_public_path__ + "img/commander-bg.03982ddd.jpg";